<template>
  <el-card class="main-card">
    <!--height="250"--->
      <el-table size="mini"
        tooltip-effect="dark"
        :empty-text = "slot='Selecciona puntos de ruta'"
        height="339"
        :data="value">
        <el-table-column label="ID" min-width="60" show-overflow-tooltip>
          <template slot-scope="scope">
            <p class="route-id-cell">{{ scope.row.routes_id }}</p>
          </template>
        </el-table-column>
        <el-table-column label="GEO"
                         align="left"
                         min-width="45"
                         property="geo_state_id">
          <template slot-scope="scope">
            <el-tag :type="scope.row.point.geo_states_id === 4 ? 'primary' : 'success'"
                    disable-transitions>{{scope.row.point.geo_states_id}}
            </el-tag>
          </template>
          <template slot-scope="scope">
            <span v-if="scope.row.point.geo_states_id === 4"
                  class="fa-stack fa-2x clickeable"
                  @click="linkBlank(scope.row.code)">
              <i class="fas fa-map-marked-alt fa-stack-2x"/>
            </span>
            <span v-else @click="linkBlank(scope.row.code)">
              <i class="el-icon-edit" style="font-size: 14px; color: #AAD500;"/>
            </span>
          </template>
        </el-table-column>
        <el-table-column property="plate.plate"
                         show-overflow-tooltip
                         label="PATENTE" min-width="80">
        </el-table-column>
        <el-table-column property="code"
                         label="SOC"
                         min-width="100"
                         show-overflow-tooltip>
        </el-table-column>
        <el-table-column property="lpn"
                         label="LPN"
                         min-width="100"
                         show-overflow-tooltip>
        </el-table-column>
        <el-table-column property="total_volumen"
                         label="VOLUMEN"
                         show-overflow-tooltip
                         min-width="100">
          <span slot-scope="scope">{{scope.row.total_volumen | truncateDecimal}} mt³</span>
        </el-table-column>
        <el-table-column property="document_type"
                         label="TIPO"
                         show-overflow-tooltip
                         min-width="130">
        </el-table-column>
        <el-table-column property="requested_at"
                         label="F. PACTADA"
                         show-overflow-tooltip
                         min-width="100">
          <span slot-scope="scope">{{scope.row.requested_at | formatDate}}</span>
        </el-table-column>
        <el-table-column property="locality"
                         label="LOCALIDAD"
                         show-overflow-tooltip
                         min-width="100">
          <span slot-scope="scope">{{scope.row.locality.toUpperCase()}}</span>
        </el-table-column>
        <el-table-column property="raw_address"
                         label="DIRECCIÓN"
                         show-overflow-tooltip
                         min-width="100">
          <span slot-scope="scope">{{scope.row.raw_address.toUpperCase()}}</span>
        </el-table-column>
      </el-table>
      <div>
        <el-select  v-model="vehicle"
                    value-key="id"
                    clearable
                    placeholder="SELECCIONA PATENTE">
          <el-option  v-for="v in vehicles"
                      :key="v.id"
                      :label="v.plate"
                      :value="{id: v.id, plate: v.plate,
                      volume_rate: v.volume_rate, route_id: v.route_id}"/>
        </el-select>
      </div>
      <div class="info-title">CAPACIDAD OCUPADA VEHÍCULO {{value.length}}</div>
      <div>
        <el-progress :percentage="vehicle_rate_ptge" :stroke-width="10"/>
      </div>
    <div class="info-warning" v-show="vehicle.volume_rate > 1">
        EXCEDES LA CAPACIDAD DEL VEHÍCULO
    </div>
    <div>
      <el-button class="default btn-modify-config" @click="emitModifyAction()">
        MODIFICAR PLANIFICACIÓN</el-button>
    </div>
  </el-card>
</template>
<script>
import moment from 'moment';
import { geoUpdateHandlerEditRoutes, manageSession } from '../../../mixins/manageSession';

export default {
  name: 'selected',
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    vehicles: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      vehicle: {},
    };
  },
  created() {
    const self = this;
    if (window.addEventListener) {
      window.addEventListener('storage', geoUpdateHandlerEditRoutes(
        (code) => {
          // const indx = self.selectedMarkId.findIndex(val => val.id === code);
          // self.selectedMarkId[indx].geo_states_id = 6;
          self.newPage.close();
          this.$emit('reload', code);
        },
      ), false);
    }
  },
  methods: {
    linkBlank(soc) {
      const routeData = this.$router.resolve({ name: 'Geocode', query: { v: 'fromSubs' } });
      sessionStorage.setItem('suborders', JSON.stringify([soc]));
      manageSession();
      window.name = 'geosortMain';
      this.newPage = window.open(routeData.href, 'geocode');
    },
    emitGeoAction(code) {
      this.$emit('geoAction', code);
    },
    emitModifyAction() {
      if (!this.vehicle.route_id) {
        this.$notify.warning({
          title: 'Acción incorrecta',
          message: 'Seleccione una patente',
        });
      } else if (this.value.length < 1) {
        this.$notify.warning({
          title: 'Acción incorrecta',
          message: 'No hay subórdenes para modificar',
        });
      } else if (this.value.some(suborder => !suborder.lpn)) {
        this.$notify.warning({
          title: 'Acción incorrecta',
          message: 'Hay subórdenes seleccionadas sin LPN asociado',
        });
      } else {
        this.$emit('moveToRoute',
          this.vehicle.route_id, this.value.map(suborder => suborder.code));
      }
    },
  },
  computed: {
    vehicle_rate_ptge() {
      if (this.vehicle.volume_rate) {
        return Math.round(this.vehicle.volume_rate * 100);
      }
      return 0;
    },
  },
  filters: {
    truncateDecimalOld(number) {
      if (number) {
        const t = number.toString();
        const regex = /(\d*.\d{0,4})/;
        return t.match(regex)[0];
      }
      return 0;
    },
    truncateDecimal(number) {
      return number ? number.toFixed(4) : 0;
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY');
    },
  },
};
</script>
<!--suppress CssInvalidPseudoSelector -->
<style lang="scss" scoped>
  .main-card{
    text-align: center;
    .route-id-cell{}
    ::v-deep .el-card__body{
      padding: 0px;
    }
    ::v-deep .el-table{
      width: 100%;
      font-size: 10px;
      td {
        padding:2px;
      }
      .route-id-cell{
        font-size: 10px;
        white-space: nowrap;
        overflow: hidden;
        direction: rtl !important;
        text-overflow: ellipsis;
      }
    }
    .el-select{
      width: 230px;
      margin-top: 13px;
    }
    .el-progress{
      width: 240px;
      display: inline-block;
      padding-bottom: 15px;
    }
    height: 535px;
  }
  .info-warning{
    color: #F5A623;
    font-size: 12px;
    margin-top:-12px;
  }
  .info-title{
    color: #a5a5a5;
    font-size: 12px;
    padding: 10px;
  }
  .btn-modify-config {
    margin-top:10px;
  }
  .fa-stack {
    width: 21px;
    height: 16px;
    line-height: 1px;
    i { font-size: 13px; }
  }
</style>
